// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-height: 85px;
}

.timeFormatted {
  font-size: 1.7rem;
  font-weight: 800;
}

.dayFormatted {
  font-size: 1rem;
  text-transform: uppercase;
}

.dateFormatted {
  text-transform: capitalize;
  font-size: 1rem;
}

.creazione {
  color: var(--color-primary);
}

.titoletto-small,
ion-item p.titoletto-small {
  font-size: 0.8rem;
  white-space: normal;
}

.sottotitoletto-small,
ion-item p.sottotitoletto-small {
  font-size: 0.7rem;
  margin-top: -4px;
}

.list,
ion-item p.list {
  font-size: 1rem;
  color: #222;
  margin: 0;
  padding: 0;
  margin-top: -5px;
}

.div-storico {
  margin-bottom: 10px;
  margin-left: 10px;
}

.inrichiesta {
  margin-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/info-rilevazione/info-rilevazione.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,gBAAA;AACJ;;AACA;EACI,eAAA;EACA,yBAAA;AAEJ;;AAAA;EACI,0BAAA;EACA,eAAA;AAGJ;;AADA;EACI,2BAAA;AAIJ;;AAAA;;EAEI,iBAAA;EACA,mBAAA;AAGJ;;AAAA;;EAEI,iBAAA;EACA,gBAAA;AAGJ;;AAAA;;EAEI,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAGJ;;AAAA;EACI,mBAAA;EACA,iBAAA;AAGJ;;AAAA;EACI,kBAAA;AAGJ","sourcesContent":[":host {\n    display:block;\n    min-height: 85px;\n}\n\n.timeFormatted {\n    font-size: 1.7rem;\n    font-weight: 800;\n}\n.dayFormatted {\n    font-size: 1rem;\n    text-transform: uppercase;\n}\n.dateFormatted {\n    text-transform: capitalize;\n    font-size: 1rem;\n}\n.creazione {\n    color: var(--color-primary);\n}\n\n  \n.titoletto-small,\n    ion-item p.titoletto-small {\n    font-size: 0.8rem;\n    white-space: normal;\n}\n\n.sottotitoletto-small,\n    ion-item p.sottotitoletto-small {\n    font-size: 0.7rem;\n    margin-top: -4px;\n}\n    \n.list,\n  ion-item p.list {\n    font-size: 1rem;\n    color: #222;\n    margin: 0;\n    padding: 0;\n    margin-top: -5px;\n}\n  \n.div-storico {\n    margin-bottom: 10px;\n    margin-left: 10px;\n}\n  \n.inrichiesta {\n    margin-bottom: 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
